<template>
  <div id="offres-exclusives-hortense">
    <!-- Banner Section -->
    <div class="banner-section" :style="{ backgroundImage: `url('https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/offres-exclusives-hortense-banner.webp')` }">
      <div class="banner-overlay">
        <h1 :class="isPhone ? 'merriweather-reg-32' : 'merriweather-reg-40'">Nos offres exclusives</h1>
        <h2 :class="isPhone ? 'merriweather-light-20' : 'merriweather-light-24'">Des privilèges exclusifs pour prolonger l’évasion</h2>
      </div>
    </div>

    <section class="featured-offers">
      <!-- Offers Description Section -->
      <div class="offers-intro">
        <article class="intro-text">
          <p v-if="!isPhone">
            Parce que chaque parenthèse mérite d'être exceptionnelle, Hortense a
            imaginé pour vous des offres exclusives, pensées pour prolonger vos
            instants d'évasion. Que vous choisissiez de vous accorder un long
            week-end ressourçant ou de vous offrir un séjour prolongé au cœur de
            nos adresses d'exception, vous profitez de réductions uniques
            réservés au membre du Club Hortense.
          </p>
          <div class="separator" v-if="!isPhone"></div>
          <div class="offers-grid">
            <div class="offer-card">
              <h3>OFFRE LONG WEEK-END</h3>
              <p class="offer-duration">Dès 3 nuits</p>
              <p class="offer-description">Savourez un long week-end tout en douceur.</p>
              <button class="btn hortense-btn-primary long-weekend-btn" @click="redirectTo('offres-long-week-end')">DÉCOUVRIR LES OFFRES</button>
            </div>
            <div class="offer-card">
              <h3>OFFRE LONG SÉJOUR</h3>
              <p class="offer-duration">Dès 7 nuits</p>
              <p class="offer-description">Laissez durer le plaisir de l'évasion éco-chic.</p>
              <button class="btn hortense-btn-primary long-stay-btn" @click="redirectTo('offres-long-sejour')">DÉCOUVRIR LES OFFRES</button>
            </div>
          </div>
        </article>
        <div class="intro-images" v-if="!isPhone">
          <img src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/offres_exclusives_1.jpg" alt="Long Weekend" v-set-alt />
          <img src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/offres_exclusive_2.jpg" alt="Long Stay" class="offset" v-set-alt />
          <img src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/offres_exclusive_3.jpg" alt="Exclusive Offer" v-set-alt />
        </div>
      </div>

      <!-- Featured Properties Carousel -->
      <div class="featured-carousel">
        <header class="section-header">
          <h2 :class="isPhone ? 'merriweather-reg-28' : 'merriweather-reg-40'">À la une</h2>
          <p :class="isPhone ? 'merriweather-light-20' : 'merriweather-light-24'">
            <span>Laissez-vous inspirer par nos </span>
            <span :class="isPhone ? 'merriweather-italic-18' : 'merriweather-light-italic-24'">sélections du moment</span>
          </p>
        </header>
        <GenericLodgingsDisplay
          v-if="featuredLodgings.length > 0"
          class="w-100"
          :lodgings="featuredLodgings"
          :user="user"
          :withDiscountBadges="true"
        />
        <button class="hortense-btn-primary" @click="redirectTo('offres-exclusives')">Découvrir toutes nos offres</button>
      </div>

      <!-- Exclusive Offers Grid -->
      <div class="exclusive-grid">
        <header class="section-header">
          <h2>
            <span :class="isPhone ? 'merriweather-reg-20' : 'merriweather-reg-26'">{{ isPhone? 'Nos' : 'Nos Offres'}}</span><br />
            <span :class="isPhone ? 'merriweather-reg-28' : 'merriweather-reg-40'">{{ isPhone? 'Offres exclusives' : 'Exclusives'}}</span>
          </h2>
          <a class="raleway-semi-p15 ml-2 text-green text-underline cursor-pointer" @click="showMap = true">Voir sur la carte</a>
        </header>

        <div class="tabs-container">
          <div class="tabs">
            <button
              v-for="tab in tabs"
              :key="tab.id"
              :class="['tab', activeTab === tab.id ? 'active raleway-semi-p15' : '']"
              @click="activeTab = tab.id"
            >
              {{ tab.label }}
            </button>
          </div>

          <!-- Subtabs Section -->
          <div class="subtabs-section">
            <!-- Période Subtabs -->
            <div v-if="activeTab === 'periode'" class="subtabs">
              <button
                v-for="subtab in periodeSubtabs"
                :key="subtab.id"
                :class="['subtab text-uppercase', selectedSeason === subtab.id ? 'active raleway-extra-bold-p15' : 'raleway-bold-p15']"
                @click="filterBySeason(subtab.id)"
              >
                {{ subtab.label }}
              </button>
            </div>

            <!-- Destination Subtabs -->
            <div v-if="activeTab === 'destination'" class="subtabs">
              <button
                v-for="subtab in destinationSubtabs"
                :key="subtab.id"
                :class="['subtab text-uppercase', selectedDestination === subtab.id ? 'active raleway-extra-bold-p15' : 'raleway-bold-p15']"
                @click="filterByDestination(subtab.id)"
              >
                {{ subtab.label }}
              </button>
            </div>

            <!-- Durée Subtabs -->
            <div v-if="activeTab === 'duree'" class="subtabs subtabs-with-info">
              <button
                v-for="subtab in dureeSubtabs"
                :key="subtab.id"
                :class="['subtab text-uppercase', selectedDuration === subtab.id ? 'active raleway-extra-bold-p15' : 'raleway-bold-p15']"
                @click="filterByDuration(subtab.id)"
              >
                <span class="subtab-label text-uppercase">{{ subtab.label }}</span>
                <span class="subtab-info">{{ subtab.info }}</span>
              </button>
            </div>
          </div>
        </div>

        <div v-if="loading" class="loading-spinner">
          <p>Chargement des offres...</p>
        </div>

        <div v-else-if="filteredLodgings.length > 0" class="properties-grid">
          <div v-for="property in filteredLodgings" :key="property.id" class="property-item">
            <CardProductHome :lodging="property" :showDiscountBadges="true" :showOnMap="true" :lodgings="filteredLodgings" :user="user || {}" />
          </div>
        </div>

        <div v-else class="empty-state">
          <p>Aucune offre disponible pour cette sélection.</p>
        </div>

        <nav v-if="totalPages > 1" class="pagination-container mt-4">
          <ul class="pagination">
            <li class="page-item">
              <button
                v-for="pageNumber in pages"
                :key="pageNumber"
                :class="currentPage === pageNumber ? 'active-item' : ''"
                type="button"
                class="page-link"
                @click="goToPage(pageNumber)">
                {{ pageNumber }}
              </button>
            </li>
          </ul>
        </nav>
      </div>
    </section>

    <!-- Club Section -->
    <section class="club-section">
      <div class="club-content">
        <h2>
          <span :class="isPhone ? 'merriweather-reg-28' : 'merriweather-reg-40'">Le Club Hortense</span>
        </h2>
        <p class="mt-1" :class="isPhone ? 'merriweather-light-18' : 'merriweather-light-24'">des
          <span :class="isPhone ? 'merriweather-italic-18' : 'merriweather-light-italic-24'"> privilèges exclusifs </span>
          à chaque séjour</p>
        <p class="mt-3 mb-3" :class="isPhone ? 'merriweather-light-16' : 'merriweather-light-24'">
          <span>Rejoignez le Club Hortense pour profiter des </span>
          <span :class="isPhone ? 'merriweather-italic-16' : 'merriweather-light-italic-24'">offres exclusives</span>
          <span> réservés aux membres</span>
        </p>
        <button class="hortense-btn-primary mb-3" @click="showModal = true">REJOINDRE LE CLUB</button>
        <a href="/le-club-hortense" class="learn-more" target="_blank">En savoir plus sur le Club Hortense</a>
      </div>
    </section>
    
    <!-- Map Modal -->
    <div v-if="showMap" class="map-modal-overlay" @click="showMap = false">
      <div class="map-modal-content" @click.stop>
        <button class="map-modal-close" v-if="!isPhone" @click="showMap = false">
          <i class="fas fa-times"></i>
        </button>
        <Maptest 
          :markers="mapMarkers" 
          :lodgings="mapLodgings"
          :showV10="true"
          @close="showMap = false"
        />
      </div>
    </div>
    <Modalsignup v-if="showModal" @close="showModal = false"></Modalsignup>
    
    <!-- Auth Modals for Offres Page (without close button) -->
    <ModalSignUpOffres 
      v-if="showSignUpOffres" 
      @close="handleSignupOffresClose"
      @showSignup="handleSignupOffresClose"
    ></ModalSignUpOffres>
    <ModalLoginOffres 
      v-if="showLoginOffres" 
      @close="handleLoginOffresClose"
      @showSignup="handleLoginOffresShowSignup"
    ></ModalLoginOffres>
  </div>
</template>

<script>
import CardProductHome from '../components/cards/CardProductHome.vue';
import GenericLodgingsDisplay from '../components/shared/GenericLodgingsDisplay.vue';
import fetcher from 'packs/shared/api.js';
import Modalsignup from '../components/modals/Modalsignup.vue';
import ModalSignUpOffres from '../components/modals/ModalSignUpOffres.vue';
import ModalLoginOffres from '../components/modals/ModalLoginOffres.vue';
import Maptest from '../components/Maptest.vue';

export default {
  name: 'OffresExclusivesHortense',
  components: {
    CardProductHome,
    GenericLodgingsDisplay,
    Modalsignup,
    ModalSignUpOffres,
    ModalLoginOffres,
    Maptest
  },
  props: {
    featuredLodgings: {
      type: Array,
      default: () => []
    },
    exclusiveLodgings: {
      type: Array,
      default: () => []
    },
    user: {
      type: Object,
      default: null
    },
    pagination: {
      type: Object,
      default: () => ({
        current_page: 1,
        per_page: 9,
        total_count: 0,
        total_pages: 1
      })
    }
  },
  data() {
    return {
       showMap: false,

      // Map data – loaded lazily when the map modal opens
      mapLodgings: [],
      mapLoading: false,
      mapLoaded: false,

      showModal: false,
      showSignUpOffres: false,
      showLoginOffres: false,
      isPhone: window.innerWidth <= 768,
      loading: false,
      filteredLodgings: [],
      activeTab: 'periode',
      tabs: [
        { id: 'periode', label: 'Période' },
        { id: 'destination', label: 'Destination' },
        { id: 'duree', label: 'Durée' }
      ],
      periodeSubtabs: [
        { id: 'hiver', label: 'Hiver' },
        { id: 'printemps', label: 'Printemps' },
        { id: 'ete', label: 'Été' },
        { id: 'automne', label: 'Automne' }
      ],
      destinationSubtabs: [
        { id: 'bord-de-mer', label: 'Bord de mer' },
        { id: 'montagne', label: 'Montagne' },
        { id: 'campagne', label: 'Campagne' },
        { id: 'ville', label: 'Ville' }
      ],
      dureeSubtabs: [
        { id: 'long-stay', label: 'Long séjour', info: '8 nuits et plus pour une immersion totale' },
        { id: 'weekend', label: 'Week-end prolongé', info: '3 nuits minimum pour déconnecter' }
      ],
      selectedDuration: 'long-stay',
      selectedDestination: 'bord-de-mer',
      selectedSeason: 'hiver',
      currentPage: 1,
      perPage: 9,
      totalCount: 0,
      totalPages: 1
    };
  },
  mounted() {
    const navbarItems = document.querySelectorAll('.bm-burger-bars');

    navbarItems.forEach((bar) => {
      bar.style.color = 'white';
      bar.style.backgroundColor = 'white';
      bar.style.border = '0.5px solid white';
    });
    
    this.filteredLodgings = this.exclusiveLodgings;
    this.currentPage = this.pagination.current_page || 1;
    this.perPage = this.pagination.per_page || 9;
    this.totalCount = this.pagination.total_count || 0;
    this.totalPages = this.pagination.total_pages || 1;
    window.addEventListener('resize', this.handleResize);
    
    // Setup Intersection Observer for featured-carousel
    this.$nextTick(() => {
      this.setupCarouselObserver();
    });
    
    // Fetch initial offers with default selections
    if (!this.exclusiveLodgings || this.exclusiveLodgings.length === 0) {
        this.fetchExclusiveOffers();
    }
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      this.isPhone = window.innerWidth <= 768;
    },
    setupCarouselObserver() {
      const carouselElement = document.querySelector('.featured-carousel');
      if (!carouselElement) return;

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && (!this.user || Object.keys(this.user).length === 0)) {
            this.showSignUpOffres = true;
            observer.unobserve(carouselElement);
          }
        });
      }, {
        threshold: 0.1
      });

      observer.observe(carouselElement);
    },
    filterByDuration(duration) {
      this.selectedDuration = duration;
      this.activeTab = 'duree';
      this.currentPage = 1;
      this.fetchExclusiveOffers();
      this.scrollToTabsContainer();
    },
    filterBySeason(season) {
      this.selectedSeason = season;
      this.currentPage = 1;
      this.fetchExclusiveOffers();
    },
    filterByDestination(destination) {
      this.selectedDestination = destination;
      this.currentPage = 1;
      this.fetchExclusiveOffers();
    },
    async fetchExclusiveOffers() {
      try {
        console.log('fetchExclusiveOffers', Date.now(), {
            activeTab: this.activeTab,
            page: this.currentPage
          });

        this.loading = true;
        const params = new URLSearchParams();
        
        params.append('page', this.currentPage);
        
        // Only pass subtab params if their corresponding tab is active
        if (this.activeTab === 'duree' && this.selectedDuration) {
          params.append('duration', this.selectedDuration);
        }
        if (this.activeTab === 'destination' && this.selectedDestination) {
          params.append('destination', this.selectedDestination);
        }
        if (this.activeTab === 'periode' && this.selectedSeason) {
          params.append('season', this.selectedSeason);
        }

        const queryString = params.toString();
        const url = `/offres-exclusives-hortense?${queryString}`;
        
        const response = await fetcher.get(url);
        this.filteredLodgings = response.data.exclusive_lodgings || [];
        this.totalCount = response.data.pagination.total_count;
        this.totalPages = response.data.pagination.total_pages;
        this.currentPage = response.data.pagination.current_page;
      } catch (error) {
        console.error('Error fetching exclusive offers:', error);
      } finally {
        this.loading = false;
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.fetchExclusiveOffers();
        this.scrollToTabsContainer();
      }
    },
    previousPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.fetchExclusiveOffers();
        this.scrollToTabsContainer();
      }
    },
    goToPage(pageNumber) {
      this.currentPage = pageNumber;
      this.fetchExclusiveOffers();
      this.scrollToTabsContainer();
    },
    scrollToTabsContainer() {
      this.$nextTick(() => {
        const tabsContainer = document.querySelector('.tabs-container');
        if (tabsContainer) {
          tabsContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    },
    redirectTo(page) {
      window.open(`/${page}`, "_blank");
    },
    async fetchMapData() {
      if (this.mapLoaded || this.mapLoading) return;
      try {
        this.mapLoading = true;
        const response = await fetcher.get('/offres-exclusives-hortense/map-data');
        this.mapLodgings = response.data.map_lodgings || [];
        this.mapLoaded = true;
      } catch (error) {
        console.error('Error fetching map data:', error);
      } finally {
        this.mapLoading = false;
      }
    },
    handleSignupOffresClose() {
      this.showSignUpOffres = false;
    },
    handleLoginOffresClose() {
      this.showLoginOffres = false;
    },
    handleLoginOffresShowSignup() {
      this.showLoginOffres = false;
      this.showSignUpOffres = true;
    },
    handleSignupOffresShowLogin() {
      this.showSignUpOffres = false;
      this.showLoginOffres = true;
    }
  },
  watch: {
    activeTab() {
      this.currentPage = 1;
      this.fetchExclusiveOffers();
    },
    showMap(val) {
      if (val) {
        // Lazy-load lean map data the first time the modal is opened
        this.fetchMapData();
      }
    }
  },
  computed: {
    pages() {
      const pageArray = [];
      for (let i = 1; i <= this.totalPages; i++) {
        pageArray.push(i);
      }
      return pageArray;
     },
     mapMarkers() {
       return this.mapLodgings.map(lodging => [
         lodging.longitude,
         lodging.latitude,
         lodging.id,
         lodging.lowest_price || 0
       ]);
    }
  }
};
</script>

<style>
#offres-exclusives-hortense {
  .hub-img, .hub-img-zoom {
    width: 100% !important;
    height: 300px !important;
  }
  
  @media screen and (max-width: 767px) {
    #generic-lodgings-display {
      .hub-img, .hub-img-zoom {
        height: 440px !important;
      }
    } 
  }
}
</style>

<style scoped lang="scss">
#offres-exclusives-hortense {
  width: 100%;
}

.pagination-container {
  display: flex;
  justify-content: start;
  align-items: start;
  width: 100%;
  margin: 40px 0;
}

.pagination {
  display: flex;
  list-style: none;
  padding: 0;
  margin: 0;
  gap: 10px;
  flex-wrap: wrap;
  justify-content: center;
}

.page-item {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  justify-content: center;
}

.page-link {
  display: inline-block;
  min-width: 40px;
  height: 40px;
  padding: 8px 12px;
  border: 1px solid #ddd;
  background-color: #fff;
  color: #333;
  text-align: center;
  cursor: pointer;
  border-radius: 4px;
  font-weight: 500;
  transition: all 0.3s ease;
  font-family: 'Raleway', sans-serif;
  font-size: 14px;

  &:hover {
    background-color: #f5f5f5;
    border-color: #3B6152;
    color: #3B6152;
  }

  &.active-item {
    background-color: #3B6152;
    color: white;
    border-color: #3B6152;

    &:hover {
      background-color: #2d4a3d;
    }
  }
}

.banner-section {
  height: 420px;
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  @media screen and (max-width: 767px) {
    height: 391px;
    margin-bottom: 40px;
  }

  .banner-overlay {
    text-align: center;
    color: white;
    z-index: 2;
  }

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.3);
    z-index: 1;
  }
}

.featured-offers {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 60px;
  padding: 80px 20px;
  width: 100%;

  @media screen and (max-width: 767px) {
    gap: 80px;
    padding: 40px 16px;
  }
}

.offers-intro {
  display: flex;
  align-items: center;
  gap: 85px;
  width: 100%;
  max-width: 1446px;

  @media screen and (max-width: 1024px) {
    gap: 40px;
  }

  @media screen and (max-width: 767px) {
    flex-direction: column;
    gap: 40px;
  }
}

.intro-text {
  display: flex;
  flex-direction: column;
  max-width: 535px;
  gap: 24px;
  flex: 1;

  @media screen and (max-width: 767px) {
    max-width: 100%;
    width: 100%;
  }

  > p {
    font-family: 'Raleway', Helvetica, sans-serif;
    font-weight: 300;
    font-size: 15px;
    line-height: 1.6;
    color: #333;
    margin: 0;
  }
}

.separator {
  width: 100%;
  height: 1px;
  background: #eee;
}

.offers-grid {
  display: flex;
  gap: 82px;

  @media screen and (max-width: 767px) {
    flex-direction: column;
    gap: 30px;
  }
}

.offer-card {
  display: flex;
  flex-direction: column;
  gap: 16px;

  h3 {
    font-family: 'Raleway', Helvetica, sans-serif;
    font-weight: 700;
    font-size: 16px;
    color: #3B6152;
    margin: 0;
    letter-spacing: 1px;
  }
}

.offer-duration {
  font-family: 'Raleway', Helvetica, sans-serif;
  font-weight: 700;
  font-size: 20px;
  color: #333;
  margin: 0;
}

.offer-description {
  font-family: 'Raleway', Helvetica, sans-serif;
  font-size: 15px;
  line-height: 1.6;
  color: #333;
  margin: 0;
  max-width: 227px;
}

.btn {
  padding: 12px 24px;
  border: none;
  border-radius: unset;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 1px;
  transition: background 0.3s ease;
  align-self: flex-start;
  outline: none !important;
  box-shadow: none !important;

  &.long-weekend-btn {
    background-color: #A5D3AE !important;
    color: #3B6152 !important;
  }

  &.long-stay-btn {
    background-color: #CFE5DC !important;
    color: #3B6152 !important;
  }

  &.btn-primary {
    background: #588968;
    color: white;

    &:hover {
      background: #4a7556;
    }
  }
}

.btn:focus,
.btn:active:focus,
.btn.active:focus,
.btn:active,
.btn.active {
  outline: none !important;
  box-shadow: none !important;
}

.intro-images {
  display: flex;
  gap: 16px;
  flex: 1;
  justify-content: end;

  @media screen and (max-width: 767px) {
    width: 100%;
    justify-content: center;
  }

  img {
    width: 220px;
    height: 450px;
    object-fit: cover;

    @media screen and (max-width: 767px) {
      width: 150px;
      height: 300px;
    }

    &.offset {
      margin-top: 80px;

      @media screen and (max-width: 767px) {
        margin-top: 40px;
      }
    }
  }
}

.featured-carousel {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 64px;
  width: 95%;

  @media screen and (max-width: 767px) {
    gap: 40px;
    padding: 0;
    width: 100%;
  }
}

.section-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  text-align: center;
  @media screen and (max-width: 767px) {
    width: 95%;
  }

  h2 {
    margin: 0;
    letter-spacing: 0.5px;
  }

  p {
    margin: 0;
    letter-spacing: 0.5px;
  }
}

.exclusive-grid {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 40px;
  max-width: 85%;
  width: 90%;
  margin: 0 auto;

  @media screen and (max-width: 767px) {
    gap: 40px;
    width: 100%;
    max-width: 100%;
  }
}

.tabs-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 40px;
  width: 100%;
}

.tabs {
  display: flex;
  justify-content: center;
  gap: 40px;
  padding: 0 10px;
  width: fit-content;
  background: #F7F7F7;
  border-radius: 4px;

  @media screen and (max-width: 767px) {
    gap: 20px;
    padding: 0 10px;
    flex-wrap: wrap;
    width: 100%;
    justify-content: space-between;
  }
}

.tab {
  background: none;
  border: none;
  padding: 8px 40px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  color: #999;
  border-bottom: 2px solid transparent;
  transition: all 0.3s ease;

  &.active {
    background-color: #fff;
    color: #000000;
    margin-top: 3px;
    margin-bottom: 3px;
    border-radius: 4px;
  }

  &:hover {
    color: #333;
  }

  @media screen and (max-width: 767px) {
    padding: 8px 15px;
  }
}

.subtabs-section {
  display: flex;
  justify-content: center;
  width: 100%;
}

.subtabs {
  display: flex;
  justify-content: space-between;
  gap: 60px;
  flex-wrap: wrap;
  width: 700px;

  @media screen and (max-width: 767px) {
    gap: 30px;
    width: 100%;
    justify-content: space-around;
    column-gap: 5px;
  }

  &.subtabs-with-info {
    gap: 80px;

    @media screen and (max-width: 767px) {
      gap: 40px;
    }
  }
}

.subtab {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  color: #4D4D4D;
  border-bottom: 2px solid transparent;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  align-items: center;

  .subtab-label {
    font-family: 'Raleway', Helvetica, sans-serif;
    font-weight: 800;
    font-size: 15px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  .subtab-info {
    font-family: 'Raleway', Helvetica, sans-serif;
    font-weight: 500;
    font-size: 15px;
    color: #000;
    text-transform: none;
    letter-spacing: 0;
  }

  &.active {
    border-bottom-color: #3B6152;
    border-bottom-width: 2px;
    color: #000;
  }
}

.properties-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 64px;
  width: 100%;
  max-width: 100%;
  overflow: hidden;

  @media screen and (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media screen and (max-width: 767px) {
    grid-template-columns: 1fr;
    gap: 20px;
  }
}

.loading-spinner {
  text-align: center;
  padding: 60px 20px;
  color: #999;
}

.empty-state {
  text-align: center;
  padding: 60px 20px;
  color: #999;
}

.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  margin-top: 40px;

  @media screen and (max-width: 767px) {
    gap: 15px;
    margin-top: 30px;
  }
}

.pagination-btn {
  background: #588968;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  transition: background 0.3s ease;

  &:hover:not(:disabled) {
    background: #4a7556;
  }

  &:disabled {
    background: #ccc;
    cursor: not-allowed;
  }
}

.page-info {
  font-size: 14px;
  color: #666;
}

// Club Section
.club-section {
  width: 95%;
  margin: 0px auto 80px;
  padding: 56px;
  background: url('https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/offres-exclusive-bottom.jpg') center -27rem / cover;

  @media screen and (max-width: 1024px) {
    padding: 40px;
  }

  @media screen and (max-width: 767px) {
    width: 100%;
    padding: 30px 20px;
    margin: unset;
    background: url('https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/offres-exclusive-bottom.jpg') center / cover;
  }
}

.club-content {
  display: flex;
  flex-direction: column;
  align-items: center;

  h2 {
    text-align: center;
    color: #000;
    margin: 0;
    line-height: 1.2;
  }

  > p {
    max-width: 680px;
    text-align: center;
    color: #000;
    margin: 0;
    line-height: 34px;

    @media screen and (max-width: 767px) {
      font-size: 14px;
    }
  }
}

.learn-more {
  font-family: 'Raleway', Helvetica, sans-serif;
  font-size: 15px;
  color: #333;
  text-decoration: underline;
  transition: color 0.3s ease;
  cursor: pointer;

  &:hover {
    color: #588968;
  }
}
.text-green {
  color: #2C5E4B;
}

// Map Modal Styles
.map-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
}

.map-modal-content {
  position: relative;
  width: 90%;
  height: 90vh;
  max-width: 1200px;
  background: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);

  @media screen and (max-width: 767px) {
    width: 100%;
    height: 100vh;
    max-width: 100%;
    border-radius: 0;
  }
}

.map-modal-close {
  position: absolute;
  top: 16px;
  right: 40px;
  width: 40px;
  height: 40px;
  background: white;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2001;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;

  &:hover {
    background: #f5f5f5;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }

  i {
    font-size: 20px;
    color: #333;
  }
}
</style>
